import { Button } from '@components/button';
import { EmptyState, EmptyStateProps } from '@components/empty-state';
import { IconRestart } from '@components/icons/restart';
import { IconSearch } from '@components/icons/search';
import { useScopedTranslate } from '@locale/translate';

export type EmptySearchStateProps = Pick<
  EmptyStateProps,
  'skipMargin' | 'orientation' | 'variant'
> & {
  hasFilters?: boolean;
  onClearSearch?: () => void;
};

export const EmptySearchState: React.FC<EmptySearchStateProps> = ({
  hasFilters,
  onClearSearch,
  ...rest
}) => {
  const { t } = useScopedTranslate(locale);
  return (
    <EmptyState
      {...rest}
      icon={<IconSearch />}
      header={t('header')}
      content={hasFilters ? t('contentWFilters') : t('content')}
      action={
        onClearSearch ? (
          <div>
            <Button
              variant="secondary"
              text={t('clearSearch')}
              iconLeft={<IconRestart />}
              onClick={onClearSearch}
            />
          </div>
        ) : undefined
      }
    />
  );
};

const locale = {
  en: {
    header: 'No results found',
    content: 'Try adjusting your search',
    contentWFilters:
      "There are no results based on your search\nTry adjusting your keyword or filters to find what you're looking for",
    clearSearch: 'Clear search',
  },
  is: {
    header: 'Engar niðurstöður',
    content: 'Reyndu að breyta leitarorðum',
    contentWFilters:
      'Engar niðurstöður passa við leit þína\nReyndu að breyta leitarorðum eða síum til að finna það sem þú leitar að',
    clearSearch: 'Hreinsa leit',
  },
};
